import React, { useState, useEffect, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../header/header.css";
import Logo from "../../assets/images/logo.jpg";
import SearchIcon from "@mui/icons-material/Search";
import Nav from "./nav/nav";
import Button from "@mui/material/Button";
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import UserAvatar from "../../assets/images/review_user.jpg";
import { jwtDecode } from "jwt-decode";
import { WishlistContext } from "../../context/WishlistContext";
import { CartContext } from "../../context/CartContext";
import { baseURL } from "../../constants/url";

function Header() {
  const {  fetchCartCount } = useContext(CartContext);
  const { cartCount } = useContext(CartContext);
  const { wishlistCount, fetchWishlistCount } = useContext(WishlistContext);

  const [isOpenDropDown, setIsOpenDropDown] = useState(false);
  const [user, setUser] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  const isTokenExpired = (token) => {
    try {
      const decoded = jwtDecode(token);
      return decoded.exp < Date.now() / 1000;
    } catch {
      return true;
    }
  };

  const fetchUserProfile = async (token) => {
    try {
      const res = await fetch(`${baseURL}common/profile/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const profile = await res.json();
      localStorage.setItem("user", JSON.stringify(profile));
      setUser(profile);
    } catch (error) {
      console.error("Failed to fetch profile:", error);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (token && !isTokenExpired(token)) {
      fetchUserProfile(token); // get fresh profile
      setIsLoggedIn(true);
      fetchWishlistCount();
      fetchCartCount();
    } else {
      localStorage.removeItem("authToken");
      localStorage.removeItem("user");
      setUser(null);
      setIsLoggedIn(false);
    }
  }, [fetchWishlistCount, fetchCartCount]);

  const handleLogout = async () => {
    const token = localStorage.getItem("authToken");
    try {
      await fetch(`${baseURL}common/logout/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (err) {
      console.error("Logout error:", err);
    } finally {
      localStorage.removeItem("authToken");
      localStorage.removeItem("user");
      setUser(null);
      setIsLoggedIn(false);
      navigate("/login");
    }
  };

  const handleSearch = () => {
    if (!searchTerm.trim()) return;
    navigate(`/searchproductlist?search=${encodeURIComponent(searchTerm.trim())}`);
  };

  const renderUserAvatar = () => {
    if (isLoggedIn && user?.profile_picture) {
      const imageUrl = user.profile_picture.startsWith("http")
        ? user.profile_picture
        : `${baseURL}${user.profile_picture}`;
      return `${imageUrl}?t=${new Date().getTime()}`; // cache-buster
    }
    return UserAvatar;
  };

  return (
    <>
    
       <div className="sticky-top">
      <div className="container-fluid  border_bottom bg_white_g">
        <div className="d_flex justify_sp_between align_center">
          <div className="head_top_left">
            <Link to="/privacypolicy"><Button>Privacy Policy</Button></Link>
            {/* <Link to="/contactus"><Button> Contact Us </Button></Link> */}
          </div>
          <div className="head_top_center">
            <div id="BrushCursor">
              <div className="brand p1">KTMEDU Mark Shopping Center LLP</div>
              <div className="brand p2">KTMEDU Mark Shopping Center LLP</div>
            </div>
          </div>
          <div className="head_top_right">
            
            <Link to="https://bholekinagri.org/" target="_blank" className="donation_btn">
             <FavoriteBorderIcon style={{width:"20px"}} className="donation_heart_icon"></FavoriteBorderIcon>&nbsp; Donation </Link>
          </div>
        </div>
      </div>

      <div className="container-fluid bg_white_g border_bottom">
        <div className="header pt_5">
          <div className="header_logo grid_in">
            <Link to="/"><img src={Logo} alt="Logo" className="head_img" /></Link>
          </div>

          <div className="header_search grid_in">
            <div className="search_tab_common">
              <input
                className="form-control height_35"
                placeholder="Search ..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleSearch();
                  }
                }}
              />
              <button
                type="button"
                className="search_tab_btn_common cursor_pointer"
                onClick={handleSearch}
              >
                <SearchIcon />
              </button>
            </div>
          </div>

          <div className="header_right usercart grid_in">
            <ul className="usercartul d_flex align_center">
              <li className="usercartli">
                <Link to="/wishlist" className="relative d_flex align_center gap_4">
                  <FavoriteBorderOutlinedIcon />
                  <span className="whislist_count">{wishlistCount || 0}</span>
                  <span className="hide_sm">Wishlist</span>
                </Link>
              </li>
              <li className="usercartli">
                <Link to="/cart" className="relative d_flex align_center gap_4">
                  <ShoppingCartOutlinedIcon />
                  <span className="whislist_count">{cartCount || 0}</span>
                  <span className="hide_sm">Cart</span>
                </Link>
              </li>
              <li className="usercartli">
                <ClickAwayListener onClickAway={() => setIsOpenDropDown(false)}>
                  <div
                    className="relative d_flex align_center gap_4 cursor_pointer"
                    onClick={() => setIsOpenDropDown(!isOpenDropDown)}
                  >
                    <img src={renderUserAvatar()} alt="User" className="user_img" />
                    <span className="hide_sm">
                      {isLoggedIn ? user?.first_name || "User" : "Login"}
                    </span>
                    {isOpenDropDown && (
                      <div className="selectdropdown">
                        <ul>
                          {isLoggedIn ? (
                            <>
                              <li>
                                <Link to="/profile">
                                  <Button variant="text">Profile</Button>
                                </Link>
                              </li>
                              <li>
                                <Link to="/myorder">
                                  <Button variant="text">My Orders</Button>
                                </Link>
                              </li>
                              <li>
                                <Button variant="text" onClick={handleLogout}>
                                  Logout
                                </Button>
                              </li>
                            </>
                          ) : (
                            <li>
                              <Link to="/login">
                                <Button variant="text">Login</Button>
                              </Link>
                            </li>
                          )}
                        </ul>
                      </div>
                    )}
                  </div>
                </ClickAwayListener>
              </li>
            </ul>
          </div>
        </div>
        <Nav />
      </div>
      </div>
      
    </>
  );
}

export default Header;
